import { EntityType } from 'api'
import { createAllEntitiesHook, createEntityGetterHook, createEntityHook } from './common'
import { createReferenceDataEntityHook } from './referenceData'

export const useProduct = createEntityHook(EntityType.PRODUCT)
export const useAllProducts = createAllEntitiesHook(EntityType.PRODUCT)
export const useProductGetter = createEntityGetterHook(EntityType.PRODUCT)
export const useProductReferenceData = createReferenceDataEntityHook(EntityType.PRODUCT)
